<template>
  <div>
    <div class="dashboard-title mb-lg">
      <BackButton
        link="/agency/our-directory/matchmaking"
        text="Back to Matchmaking requests"
      />
      <h1 class="fw-bold fs-xl mb-xs">{{ lead.companyName }} Match Request</h1>
    </div>
    <hr class="mb-sm" />
    <div class="grid grid--middle">
      <div class="grid__cell col3-of-12--medium-up" style="margin-bottom: 0;">
        <label>
          Status
          <div class="select">
            <select
              @change="updateStatus({ ...lead, status: $event.target.value })"
            >
              <option value="N" :selected="lead.status === 'N'">New</option>
              <option value="P" :selected="lead.status === 'P'">Pending</option>
              <option value="D" :selected="lead.status === 'D'">Done</option>
            </select>
          </div>
        </label>
      </div>
    </div>
    <hr class="mb-lg" />
    <div class="grid grid--rev">
      <div class="grid__cell col5-of-12--large-up">
        <!---->
      </div>
      <div class="grid__cell col7-of-12--large-up">
        <div class="grid">
          <div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                client name:
              </p>
              <p class="fs-sm theme-text-medium">{{ lead.companyName }}</p>
            </div>
            <div
              v-if="lead.companyWebsite"
              class="grid__cell col6-of-12--large-up mb-sm"
            >
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                Company Website:
              </p>
              <p class="fs-sm theme-text-medium">{{ lead.companyWebsite }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                status:
              </p>
              <p class="fs-sm theme-text-medium">{{ status }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                requested by:
              </p>
              <p class="fs-sm theme-text-medium">
                {{ lead.firstName + ' ' + lead.lastName }}
              </p>
              <p class="fs-sm theme-text-medium">{{ lead.email }}</p>
              <p class="fs-sm theme-text-medium">{{ lead.phone }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                request date:
              </p>
              <p class="fs-sm theme-text-medium">{{ dateSent }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                comments:
              </p>
              <p class="fs-sm theme-text-medium">{{ lead.comments }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import BackButton from '@/components/BackButton';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  'matchmakingRequests'
);

export default {
  components: {
    BackButton,
  },
  methods: {
    ...mapActions([
      'updateStatus',
      'fetchLeadsData',
      'setActiveLead',
      'fetchRequestDetail',
    ]),
    handleUpdate(val) {
      this.updateStatus({ id: this.$route.params.leadId, status: val });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('matchmakingRequests/clearQueryAndFilter');
    next();
  },
  computed: {
    ...mapGetters({ lead: 'detail' }),
    dateSent() {
      return formatDate(new Date(String(this.lead.created)));
    },
    status() {
      if (this.lead.status === 'N') return 'New';
      if (this.lead.status === 'D') return 'Done';
      if (this.lead.status === 'A') return 'Accepted';
      if (this.lead.status === 'P') return 'Pending';
      return '';
    },
  },
  mounted() {
    if (!this.detail) {
      this.fetchRequestDetail(this.$route.params.id);
    }
  },
};
</script>
